import createQueryParamsForGetReq from 'helper/createQueryParamsForGetReq';
import { useQuery } from 'react-query';

import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';

export default function Usegetblogs({
  isDeleted,
  isDraft,
  isPublished,
  searchText,
  filterValue,
}) {
  return useQuery(
    ['get-blog-data', isDeleted, isDraft, isPublished, searchText, filterValue],
    async () => {
      const response = await makeApiRequest.get(
        createQueryParamsForGetReq(apiEndPoints.ADMIN_BLOG, {
          is_deleted: isDeleted,
          is_draft: isDraft,
          is_published: isPublished,
          search: searchText,
          created_date__year: filterValue,
        })
      );

      return response.data;
    }
  );
}
